export const ORDERS = [
    {
        id: 1,
        total_price: 500,
        customer:'Chris',
        status: 1,
    },
]